import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import env from '@tencent/vft-common/env';
import MagicService from '@/service/magic';
export default {
  data: function data() {
    return {
      年卡: {},
      首月: {}
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return MagicService.openVip({
                module_id: 132269
              });

            case 3:
              _this.年卡 = _context.sent;
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);

            case 9:
              _context.prev = 9;
              _context.next = 12;
              return MagicService.openVip({
                module_id: 132355
              });

            case 12:
              _this.首月 = _context.sent;
              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t1 = _context["catch"](9);
              console.error(_context.t1);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 6], [9, 15]]);
    }))();
  },
  methods: {
    openVip: function openVip(type) {
      if (type === '年卡' || type === '首月') {
        if (this[type].check_ret !== 0) {
          console.log('没有资格');
          return;
        }
      }

      if (!this.isLogin) {
        this.$openLogin();
        return;
      }

      if (env.isKidApp) {
        this.openUrl(window.setting.开通区域[type].小企鹅app地址);
        return;
      }

      if (env.isApp) {
        this.openMidPage(window.setting.开通区域[type].视频app地址);
        return;
      }

      this.openUrl(window.setting.开通区域[type].H5地址);
    }
  }
};